<!-- edit mode for rich text -->
<div *ngIf="config && !config.readonly" [hidden]="!config||!mode" class="textarea-tile gridster-item-content"
    [froalaEditor]="options" (froalaInit)="onEditorInit($event)" [(froalaModel)]="data.html">
</div>
<!-- read mode and data.html is null -->
<div *ngIf="!data.html&&config&&!mode" class="placeholder hide-overflow-print" (click)="focusEditor()">
    <span class="text">Type something</span>
</div>
<!-- read mode for rich text -->
<div [hidden]="mode&&data.html" class="container hide-overflow-print" [innerHTML]="data.html | safeHtml"
    (click)="focusEditor()">
</div>